import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import DoDisturbOffIcon from '@mui/icons-material/DoDisturbOff';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import HomeIcon from '@mui/icons-material/Home';
import ImageIcon from '@mui/icons-material/Image';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SendIcon from "@mui/icons-material/Send";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ConfirmAction from "../../components/Common/ConfirmAction";
import { ADMIN_SERVER_BASE_URL, SITEWEB_SERVER_BASE_URL, apiClient } from "../../util/apiClient";
import { deleteEtabActive, updateEtabActivetedWebService } from "../../store/xserverSlice";
import { errorNotify, successNotify } from "../../util/functions";


export default function MenuApp(props: any) {
  //props
  const { item } = props;

  //redux
  const dispatch = useDispatch();

  //hooks
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [openComfirmDialog, setOpenComfirmDialog] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  //Ouvrir le menu
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  //Fermer le menu
  const handleClose = () => {
    setAnchorEl(null);
  };



  /////////////////////////////////////////////////  suppression  /////////////////////////////////////////////////////////
  //Ouvrir la boite de dialog 
  const handleComfirmDialogDialogOpen = () => {
    setOpenComfirmDialog(true);
  };

  //Fermer la boite de dialog 
  const handleComfirmDialogDialogClose = () => {
    setOpenComfirmDialog(false);
  };


  //Supprimer un etablissement
  const handleDelete = async (e: any) => {
    e.preventDefault();
    try {
      setDeleteLoading(true);
      const apiPayload = {
        codeEtab: item.codeEtab,
        anneeScolaire: item.anneeScolaire,
        idService: item.idService,
      };
      const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/disactivewebserviceonline", apiPayload);
      if (res.status === 1) {
        // dispatch(deleteEtabActive(item.codeEtab));

        dispatch(deleteEtabActive({
          codeEtab: item.codeEtab,
          anneeScolaire: item.anneeScolaire,
          idService: item.idService
        }));
        successNotify("Action éffectuée avec succès");
        handleComfirmDialogDialogClose()
      } else {
        errorNotify("Echèc de l'opération.");
      }
    } catch (error) {
      console.log("🚀 ~ file: MenuApp.tsx:81 ~ handleDelete ~ error:", error)
      errorNotify("Une erreur s'est produite.");
    } finally {
      setDeleteLoading(false);
    }
  };



  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <Tooltip title="Options">
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <MoreVertIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() => {
            handleComfirmDialogDialogOpen();
          }}
        >
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          Supprimer
        </MenuItem>
      </Menu>

      <ConfirmAction
        title={`${item.codeEtab}`}
        dialogContent={`Voulez vous réellement enlever le code ${item.codeEtab} en ligne ?`}
        actionLabel="Oui"
        open={openComfirmDialog}
        handleClose={handleComfirmDialogDialogClose}
        actionFunction={handleDelete}
        addLoading={deleteLoading}
        iconeSauveButton={<DeleteIcon />}
      />
    </React.Fragment>
  );
}
